<template>
  <div class="resumo-dados">
    <h4 class="titulo">Resumo de Dados</h4>
    <v-container class="pa-0">
      <!-- Documento: CNPJ ou CPF -->
      <v-layout row class="linha-dados" v-if="tipoFornecedor !== 'F'">
        <v-flex xs4 class="label-campo">{{ labelDocumento }}</v-flex>
        <v-flex xs8>
          <v-tooltip top :disabled="!isTextTruncated" open-delay="300">
            <template v-slot:activator="{ on }">
              <div
                class="valor-campo truncate-text"
                v-on="on"
                ref="docText"
                @mouseover="checkOverflow($event, 'docText')"
              >
                {{ documentoFormatado }} <!-- Exibe CPF ou CNPJ formatado -->
              </div>
            </template>
            <span>{{ documentoFormatado }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <!-- CPF (apenas para Pessoa Física) -->
      <v-layout row class="linha-dados" v-if="tipoFornecedor === 'F'">
        <v-flex xs4 class="label-campo">CPF</v-flex>
        <v-flex xs8>
          <v-tooltip top :disabled="!isTextTruncated" open-delay="300">
            <template v-slot:activator="{ on }">
              <div
                class="valor-campo truncate-text"
                v-on="on"
                ref="cpfText"
                @mouseover="checkOverflow($event, 'cpfText')"
              >
                {{ cpfFormatado }}
              </div>
            </template>
            <span>{{ cpfFormatado }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <!-- Razão Social -->
      <v-layout row class="linha-dados">
        <v-flex xs4 class="label-campo">Razão Social</v-flex>
        <v-flex xs8>
          <v-tooltip top :disabled="!isTextTruncated" open-delay="300">
            <template v-slot:activator="{ on }">
              <div
                class="valor-campo truncate-text"
                v-on="on"
                ref="razaoText"
                @mouseover="checkOverflow($event, 'razaoText')"
              >
                {{ razaoSocial }}
              </div>
            </template>
            <span>{{ razaoSocial }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <!-- CEP -->
      <v-layout row class="linha-dados">
        <v-flex xs4 class="label-campo">CEP</v-flex>
        <v-flex xs8>
          <v-tooltip top :disabled="!isTextTruncated" open-delay="300">
            <template v-slot:activator="{ on }">
              <div
                class="valor-campo truncate-text"
                v-on="on"
                ref="cepText"
                @mouseover="checkOverflow($event, 'cepText')"
              >
                {{ cep }}
              </div>
            </template>
            <span>{{ cep }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <!-- Logradouro -->
      <v-layout row class="linha-dados">
        <v-flex xs4 class="label-campo">Logradouro</v-flex>
        <v-flex xs8>
          <v-tooltip top :disabled="!isTextTruncated" open-delay="300">
            <template v-slot:activator="{ on }">
              <div
                class="valor-campo truncate-text"
                v-on="on"
                ref="logradouroText"
                @mouseover="checkOverflow($event, 'logradouroText')"
              >
                {{ logradouro }}
              </div>
            </template>
            <span>{{ logradouro }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <!-- Complemento -->
      <v-layout row class="linha-dados">
        <v-flex xs4 class="label-campo">Complemen.</v-flex>
        <v-flex xs8>
          <v-tooltip top :disabled="!isTextTruncated" open-delay="300">
            <template v-slot:activator="{ on }">
              <div
                class="valor-campo truncate-text"
                v-on="on"
                ref="complementoText"
                @mouseover="checkOverflow($event, 'complementoText')"
              >
                {{ complemento }}
              </div>
            </template>
            <span>{{ complemento }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <!-- Número -->
      <v-layout row class="linha-dados">
        <v-flex xs4 class="label-campo">Número</v-flex>
        <v-flex xs8>
          <v-tooltip top :disabled="!isTextTruncated" open-delay="300">
            <template v-slot:activator="{ on }">
              <div
                class="valor-campo truncate-text"
                v-on="on"
                ref="numeroText"
                @mouseover="checkOverflow($event, 'numeroText')"
              >
                {{ numero }}
              </div>
            </template>
            <span>{{ numero }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <!-- Bairro -->
      <v-layout row class="linha-dados">
        <v-flex xs4 class="label-campo">Bairro</v-flex>
        <v-flex xs8>
          <v-tooltip top :disabled="!isTextTruncated" open-delay="300">
            <template v-slot:activator="{ on }">
              <div
                class="valor-campo truncate-text"
                v-on="on"
                ref="bairroText"
                @mouseover="checkOverflow($event, 'bairroText')"
              >
                {{ bairro }}
              </div>
            </template>
            <span>{{ bairro }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <!-- Cidade -->
      <v-layout row class="linha-dados">
        <v-flex xs4 class="label-campo">Cidade</v-flex>
        <v-flex xs8>
          <v-tooltip top :disabled="!isTextTruncated" open-delay="300">
            <template v-slot:activator="{ on }">
              <div
                class="valor-campo truncate-text"
                v-on="on"
                ref="cidadeText"
                @mouseover="checkOverflow($event, 'cidadeText')"
              >
                {{ cidade }}
              </div>
            </template>
            <span>{{ cidade }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <!-- Botão VISUALIZAR CARTÃO CNPJ (apenas para PJ) -->
      <v-layout justify-center mt-2 v-if="tipoFornecedor === 'J'">
        <v-btn 
          color="success" 
          small 
          dark 
          class="botao-cnpj"
          @click="visualizarCartaoCnpj"
        >
          VISUALIZAR CARTÃO CNPJ
        </v-btn>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import util from "../../../../src/plugins/util";

export default {
  name: "ResumoDados",
  mixins: [util],
  props: {
    tipoFornecedor: { // 'J' para PJ, 'F' para PF
      type: String,
      required: true
    },
    documento: { // Recebe CPF ou CNPJ bruto
      type: String,
      required: true
    },
    cnpj: {
      type: String,
      default: ""
    },
    razaoSocial: {
      type: String,
      default: ""
    },
    cep: {
      type: String,
      default: ""
    },
    logradouro: {
      type: String,
      default: ""
    },
    complemento: {
      type: String,
      default: ""
    },
    numero: {
      type: [String, Number],
      default: ""
    },
    bairro: {
      type: String,
      default: ""
    },
    cidade: {
      type: String,
      default: ""
    },
    showResumoDados: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      isTextTruncated: false
    };
  },
  computed: {
    labelDocumento() {
      return this.tipoFornecedor === 'J' ? 'CNPJ' : 'CPF';
    },
    documentoFormatado() {
      return this.formatarCNPJ(this.documento);
    },
    cpfFormatado() {
      return this.formatarCPF(this.documento);
    }
  },
  methods: {
    visualizarCartaoCnpj() {
      this.$emit('visualizar-cartao-cnpj', this.cnpj);
    },
    checkOverflow(event, refName) {
      // Verifica se o texto está truncado
      const element = this.$refs[refName];
      if (element) {
        this.isTextTruncated = element.offsetWidth < element.scrollWidth;
      }
    },
    formatarCNPJ(cnpj) {
      // Formatação padrão do CNPJ: 12.345.678/0001-99
      return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    },
    formatarCPF(cpf) {
      // Formatação padrão do CPF: 123.456.789-09
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
  },
  mounted() {
    // Verifique no console se o valor está correto

  }
};
</script>

<style scoped>
.resumo-dados {
  width: 300px;
  background-color: #f8f8f8;
  border: 1px solid #e0e0e0;
  margin-left: auto;
  margin-right: auto;
  display: flex; 
  flex-direction: column; 
  align-items: center; 
}

.titulo {
  font-size: 17px;
  font-weight: bold;
  padding: 10px 0;
  margin: 0;
  text-align: center
}

.resumo-dados h4 {
  text-align: center;
  font-size: 17px;
  font-weight: bold;
  padding: 10px 0 10px 15px;
  margin: 0;
  border-bottom: 1px solid #e0e0e0;
  width: 100%;
}

.linha-dados {
  border-bottom: 1px solid #f0f0f0;
  margin: 0;
  padding: 8px 10px;
}

.label-campo {
  color: #666;
  font-weight: normal;
  text-align: left;
  margin-left: -10px;
  font-size: 14px;
  padding-right: 0 !important;
}

.valor-campo {
  color: #333;
  font-weight: normal;
  padding-left: 5px;
  font-size: 14px;
  text-align: left;
  max-width: 150px; /* Define largura máxima para forçar truncamento */
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
}

/* Estilos do tooltip */
.v-tooltip__content {
  background-color: rgba(97, 97, 97, 0.9) !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 5px 8px !important;
  font-size: 12px !important;
  max-width: 300px !important;
  word-break: normal !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

.v-container {
  padding: 0;
}

.v-btn.success {
  text-transform: uppercase;
  height: 40px;
  width: 270px;
  font-weight: normal;
  letter-spacing: 0.5px;
  margin-top: 8px;
  margin-bottom: 16px;
  background-color: #4caf50 !important;
  border-radius: 0;
}
</style>
